import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingBag, Search, User } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [announcementIndex, setAnnouncementIndex] = useState(0);
  const {
    totalItems
  } = useCart();
  const navigate = useNavigate();
  const announcements = ['Free Shipping on Orders $50+', 'New Arrivals Weekly - Check Them Out', 'Join The UNCMMN Club for 10% Off'];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnnouncementIndex(prev => (prev + 1) % announcements.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-94">
      {/* Announcement Bar */}
      <div className="bg-black text-uncommon-gold text-xs font-bold py-2 text-center tracking-widest uppercase border-b border-uncommon-grey" data-id="element-95">
        <AnimatePresence mode="wait" data-id="element-96">
          <motion.span key={announcementIndex} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.3
        }} className="inline-block" data-id="element-97">
            {announcements[announcementIndex]}
          </motion.span>
        </AnimatePresence>
      </div>

      {/* Main Navigation */}
      <nav className={`transition-all duration-300 border-b ${isScrolled || isMobileMenuOpen ? 'bg-uncommon-black/95 backdrop-blur-md border-uncommon-grey py-4' : 'bg-transparent border-transparent py-6'}`} data-id="element-98">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
          <div className="flex justify-between items-center" data-id="element-100">
            {/* Mobile Menu Button */}
            <button className="md:hidden text-white hover:text-uncommon-gold transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-101">
              {isMobileMenuOpen ? <X size={24} data-id="element-102" /> : <Menu size={24} data-id="element-103" />}
            </button>

            {/* Logo */}
            <div className="flex-shrink-0 flex items-center" data-id="element-104">
              <Link to="/" className="font-brand text-4xl md:text-5xl font-bold tracking-ultra-wide text-white group hover:text-uncommon-gold transition-colors" data-id="element-105">
                <span className="text-uncommon-gold" data-id="element-106">U</span>NCMMN
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-107">
              {[{
              name: 'Shop',
              path: '/collection/apparel'
            }, {
              name: 'Categories',
              path: '/#categories'
            }, {
              name: 'Deals',
              path: '/collection/deals'
            }].map(item => <Link key={item.name} to={item.path} className="text-sm font-medium text-white hover:text-uncommon-gold transition-colors uppercase tracking-wide" data-id="element-108">
                  {item.name}
                </Link>)}
            </div>

            {/* Icons */}
            <div className="flex items-center space-x-6" data-id="element-109">
              <button className="text-white hover:text-uncommon-gold transition-colors" aria-label="Search" data-id="element-110">
                <Search size={20} data-id="element-111" />
              </button>
              <button className="text-white hover:text-uncommon-gold transition-colors hidden sm:block" aria-label="Account" data-id="element-112">
                <User size={20} data-id="element-113" />
              </button>
              <button onClick={() => navigate('/cart')} className="text-white hover:text-uncommon-gold transition-colors relative" aria-label="Cart" data-id="element-114">
                <ShoppingBag size={20} data-id="element-115" />
                {totalItems > 0 && <motion.span initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} className="absolute -top-2 -right-2 bg-uncommon-gold text-black text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-116">
                    {totalItems}
                  </motion.span>}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-117">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="md:hidden bg-uncommon-black border-t border-uncommon-grey overflow-hidden" data-id="element-118">
              <div className="px-4 py-6 space-y-4" data-id="element-119">
                {[{
              name: 'Shop',
              path: '/collection/apparel'
            }, {
              name: 'Categories',
              path: '/#categories'
            }, {
              name: 'Deals',
              path: '/collection/deals'
            }].map(item => <Link key={item.name} to={item.path} className="block text-lg font-medium text-white hover:text-uncommon-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-120">
                    {item.name}
                  </Link>)}
                <div className="pt-4 border-t border-uncommon-grey flex space-x-4" data-id="element-121">
                  <button className="text-white flex items-center space-x-2" data-id="element-122">
                    <User size={18} data-id="element-123" />
                    <span data-id="element-124">Account</span>
                  </button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>
    </header>;
}